
























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Alert, Tag } from 'element-ui'
import SearchForm from '@/components/common/SearchForm.vue'
import GenerateScreenshotDialog from '@/components/common/GenerateScreenshotDialog.vue'
import TableForm from '@/components/common/TableForm.vue'
import { ManualRefundService } from '@/api/service/manual-refund'
import { RefundOrder, RefundAttempt, RefundPreview, RefundChannel, RefundDetail, RefundForm } from '@/api/model/manual-refund'
import { validRefundAmount, refundRequestNo, refundCommand, canRetryRefund, refundFinished, csvCell, refundAccountHash, refundAccountMask, refundPendingSnapshot, refundReceiptData } from '@/utils/manual-refund'
import { DateTime } from '@/utils/filters'
import store from '@/store'

const api = new ManualRefundService()
const blank = (): RefundForm => ({ mid: '', repaymentId: '', cardId: '', bankId: '', accountNumber: '', amount: '', channelId: null, reason: '' })
@Component({ components: { SearchForm, TableForm, GenerateScreenshotDialog, 'el-alert': Alert, 'el-tag': Tag } })
export default class ManualRefundPage extends Vue {
    search = { current: 1, size: 10, phone: '', mid: '', refundId: '', status: '', accountingState: '' }
    rows: RefundOrder[] = []; total = 0; loading = false
    formVisible = false; form = blank(); preview: RefundPreview | null = null
    channels: RefundChannel[] = []; channelsLoaded = false; channelLoading = false
    verifying = false; submitting = false; uncertain = false; refreshing = ''; reconciling = false
    retryOrder: RefundOrder | null = null; requestNo = ''; pendingCommand: any = null
    pendingConfirmation = ''; checkingSubmission = false; pendingAccountHash = ''; resumeAccount = ''
    paidVisible = false; paidAttempt: RefundAttempt | null = null; paidForm = { amount: '', providerOrderNo: '', reference: '' }
    recoveryTimer: number | null = null; recoverySequence = 0; recoveryDelay = 3000; recoveryActive = true
    receiptVisible = false; receiptLoading = ''; receiptData: any = {}; receiptSequence = 0
    detailVisible = false; detailLoading = false; detail: RefundDetail | null = null
    loadSequence = 0; previewSequence = 0; channelSequence = 0; detailSequence = 0
    statusLabels = { READY: '待发送', PROCESSING: '付款处理中', SUCCESS: '已付款', FAILED: '付款失败', REVIEW: '待核查', RETURNED: '款项已退回' }
    accountingLabels = { NONE: '无需记账', PENDING: '已付款待记账', POSTED: '已记账', REVERSED: '已冲正' }
    date = DateTime; canRetry = canRetryRefund; finished = refundFinished
    repaymentLabel(repayment): string { return '订单 ' + (repayment.orderNo || '—') + ' · 实还 ' + repayment.realAmount + ' ARS' }
    statusText(status: string): string { return this.statusLabels[status] || status }
    accountingText(state: string): string { return this.accountingLabels[state] || '—' }
    statusColor(status: string): string { return status === 'SUCCESS' ? 'success' : status === 'FAILED' ? 'danger' : status === 'RETURNED' ? 'info' : 'warning' }
    created(): void { this.getData(); this.restorePending() }
    activated(): void { this.recoveryActive = true; if (this.uncertain) this.resolveSubmission() }
    deactivated(): void { this.clearReceipt(); this.stopRecovery(); this.recoveryActive = false }
    beforeDestroy(): void { this.clearReceipt(); this.stopRecovery(); this.recoveryActive = false }
    get pendingKey(): string { const auth = (store.state as any).auth.authInfo; return 'manual-refund-pending:' + (auth ? auth.tenantId + ':' + auth.userId : 'anonymous') }
    @Watch('pendingKey')
    identityChanged(): void { this.clearReceipt(); this.formVisible = false; this.resetForm(); this.restorePending() }
    get needsResumeAccount(): boolean { return !!this.pendingAccountHash && !!this.pendingCommand && !this.pendingCommand.accountNumber }
    get paidReady(): boolean { return validRefundAmount(this.paidForm.amount) && !!this.paidForm.providerOrderNo.trim() && this.paidForm.providerOrderNo.length <= 200 && !!this.paidForm.reference.trim() && this.paidForm.reference.length <= 500 }
    get canLoadChannels(): boolean { return !!this.form.bankId && validRefundAmount(this.form.amount) && !this.verifying }
    get ready(): boolean {
        if (!this.channels.some(channel => Number(channel.channelId) === this.form.channelId) || this.channelLoading || this.verifying) return false
        if (this.retryOrder) return true
        try { refundCommand(this.preview, this.form, this.requestNo); return true } catch (_) { return false }
    }
    async getData(page = {}): Promise<void> {
        Object.assign(this.search, page)
        if ((this.search.mid && !/^[1-9]\d{0,17}$/.test(this.search.mid)) || (this.search.refundId && !/^[1-9]\d{0,17}$/.test(this.search.refundId))) { this.$message.error('用户 ID 或退款单号格式不正确'); return }
        if (this.search.phone && !/^[+]?[0-9]{6,20}$/.test(this.search.phone)) { this.$message.error('手机号格式不正确'); return }
        const seq = ++this.loadSequence; this.loading = true
        try { const result = await api.list({ ...this.search }).toPromise(); if (seq === this.loadSequence) { this.rows = result.list || []; this.total = result.total } }
        catch (error) { this.report(error) } finally { if (seq === this.loadSequence) this.loading = false }
    }
    searchRows(): void { this.search.current = 1; this.getData() }
    openCreate(): void { if (this.restorePending()) return; this.resetForm(); this.formVisible = true }
    resetForm(): void { this.stopRecovery(); this.form = blank(); this.preview = null; this.retryOrder = null; this.channels = []; this.channelsLoaded = false; this.uncertain = false; this.pendingCommand = null; this.pendingConfirmation = ''; this.pendingAccountHash = ''; this.resumeAccount = ''; this.requestNo = refundRequestNo(); ++this.previewSequence; ++this.channelSequence }
    closeForm(): void { ++this.previewSequence; ++this.channelSequence }
    invalidateUser(): void { ++this.previewSequence; this.verifying = false; this.preview = null; this.form.repaymentId = ''; this.form.cardId = ''; this.form.bankId = ''; this.form.accountNumber = ''; this.invalidateChannels() }
    invalidateChannels(): void { ++this.channelSequence; this.channels = []; this.channelsLoaded = false; this.form.channelId = null; this.channelLoading = false }
    accountChanged(): void {
        const card = this.preview && this.preview.cards.find(item => String(item.id) === this.form.cardId)
        this.form.bankId = card ? String(card.bankId) : ''; this.form.accountNumber = ''; this.invalidateChannels()
    }
    async verifyUser(): Promise<void> {
        if (!/^[1-9]\d{0,17}$/.test(this.form.mid)) { this.$message.error('请输入正确的用户 ID'); return }
        this.form.repaymentId = '';
        const seq = ++this.previewSequence; this.verifying = true; this.preview = null; this.invalidateChannels()
        try { const preview = await api.preview(this.form.mid).toPromise(); if (seq === this.previewSequence) { this.preview = preview; this.form.cardId = preview.cards.length ? String(preview.cards[0].id) : ''; this.accountChanged() } }
        catch (error) { this.report(error) } finally { if (seq === this.previewSequence) this.verifying = false }
    }
    async loadChannels(): Promise<void> {
        if (!this.canLoadChannels) return
        const seq = ++this.channelSequence; this.channelLoading = true; this.form.channelId = null
        try { const channels = await api.channels(this.form.bankId, this.form.amount).toPromise(); if (seq === this.channelSequence) { this.channels = channels; this.channelsLoaded = true; if (channels.length === 1) this.form.channelId = Number(channels[0].channelId) } }
        catch (error) { this.report(error) } finally { if (seq === this.channelSequence) this.channelLoading = false }
    }
    async openRetry(order: RefundOrder): Promise<void> { if (this.restorePending()) return; this.resetForm(); this.retryOrder = order; this.form.bankId = String(order.bankId); this.form.amount = String(order.amount); this.formVisible = true; await this.loadChannels() }
    restorePending(): boolean {
        if (this.uncertain && this.pendingCommand) { this.formVisible = true; return true }
        const saved = sessionStorage.getItem(this.pendingKey)
        if (!saved) return false
        try {
            const previous = JSON.parse(saved)
            const legacyAccount = previous.command.accountNumber || ''
            const pending = refundPendingSnapshot(previous.command, previous.summary || {
                mid: previous.command.mid || (previous.retryOrder && previous.retryOrder.customerId),
                amount: previous.command.amount || (previous.retryOrder && previous.retryOrder.amount),
                realName: previous.preview && previous.preview.realName,
                accountMask: legacyAccount || (previous.retryOrder && previous.retryOrder.accountMask),
                channelName: (previous.channels || []).filter(channel => Number(channel.channelId) === previous.command.channelId).map(channel => channel.channelName).join('')
            }, previous.accountHash)
            // 旧缓存立即脱敏；不能把旧版 confirmation / form 中的完整账号继续写回。
            sessionStorage.setItem(this.pendingKey, JSON.stringify(pending))
            this.pendingCommand = pending.command; this.pendingAccountHash = pending.accountHash; this.resumeAccount = ''; this.requestNo = pending.command.requestNo
            this.retryOrder = pending.command.refundId ? { id: pending.command.refundId } as RefundOrder : null
            this.form = { ...blank(), ...pending.command, accountNumber: '' }
            this.pendingConfirmation = this.summaryText(pending.summary)
            this.uncertain = true; this.formVisible = true; this.resolveSubmission(); return true
        }
        catch (_) { this.$message.error('本次退款提交记录无法恢复，请按退款单号核查'); return true }
    }
    summaryText(summary): string { return '用户 ID：' + summary.mid + (summary.repaymentId ? '\n关联还款单：' + summary.repaymentId : '') + '\n收款账户：' + (summary.accountMask || '沿用已绑定账户') + '\n金额：' + summary.amount + ' ARS\n渠道：' + (summary.channelName || '沿用原渠道') }
    stopRecovery(): void {
        ++this.recoverySequence; this.checkingSubmission = false
        if (this.recoveryTimer !== null) window.clearTimeout(this.recoveryTimer)
        this.recoveryTimer = null
    }
    async resolveSubmission(): Promise<void> {
        if (!this.recoveryActive || !this.uncertain || !this.pendingCommand || this.checkingSubmission || this.submitting) return
        if (this.recoveryTimer !== null) window.clearTimeout(this.recoveryTimer)
        this.recoveryTimer = null
        const sequence = ++this.recoverySequence; const owner = this.pendingKey; this.checkingSubmission = true
        try {
            const result = await api.submission(this.pendingCommand.requestNo, this.pendingCommand.refundId).toPromise()
            if (sequence !== this.recoverySequence || owner !== this.pendingKey) return
            if (result && result.found && result.order && result.order.id) { await this.acceptSubmission(result.order); return }
        } catch (_) { /* 未取得结果时保留原提交号；恢复查询不会创建或发送付款。 */ }
        finally { if (sequence === this.recoverySequence) this.checkingSubmission = false }
        if (sequence === this.recoverySequence && owner === this.pendingKey && this.recoveryActive && this.uncertain) {
            this.recoveryTimer = window.setTimeout(() => this.resolveSubmission(), this.recoveryDelay)
            this.recoveryDelay = Math.min(this.recoveryDelay * 2, 30000)
        }
    }
    async acceptSubmission(order: RefundOrder): Promise<void> {
        this.stopRecovery(); this.uncertain = false; this.formVisible = false; this.pendingCommand = null; this.pendingAccountHash = ''; this.resumeAccount = ''; this.form.accountNumber = ''; this.recoveryDelay = 3000
        try { sessionStorage.removeItem(this.pendingKey) }
        catch (_) { this.$message.warning('退款已受理，本地记录清理失败；重新打开页面会自动核实原单') }
        this.$message.success('提交成功，退款单 ' + order.id + '，请在列表查看付款结果')
        await this.getData()
    }
    async submit(): Promise<void> {
        if (this.submitting || this.checkingSubmission || (!this.uncertain && !this.ready)) return
        const wasUncertain = this.uncertain
        const owner = this.pendingKey
        this.submitting = true
        if (!this.uncertain) {
            const command = this.retryOrder ? { refundId: this.retryOrder.id, channelId: this.form.channelId, requestNo: this.requestNo } : refundCommand(this.preview, this.form, this.requestNo)
            const account = this.retryOrder ? this.retryOrder.accountMask : this.form.cardId ? this.preview!.cards.find(card => String(card.id) === this.form.cardId)!.accountMask : this.form.accountNumber
            const name = this.retryOrder ? this.retryOrder.realName : this.preview!.realName
            const channel = this.channels.find(item => Number(item.channelId) === this.form.channelId)!
            this.pendingConfirmation = '收款人：' + name + '\n账号：' + account + '\n金额：' + this.form.amount + ' ARS' + (!this.retryOrder ? '\n关联还款单：' + this.form.repaymentId : '') + '\n渠道：' + channel.channelName
            try { await this.$confirm(this.pendingConfirmation, '确认退款', { confirmButtonText: '确认提交', cancelButtonText: '返回修改', type: 'warning', customClass: 'refund-confirm' }) }
            catch (_) { this.submitting = false; return }
            if (owner !== this.pendingKey) { this.submitting = false; return }
            this.pendingCommand = command
            try {
                const pending = refundPendingSnapshot(command, { mid: this.retryOrder ? this.retryOrder.customerId : this.form.mid, amount: this.form.amount, realName: name, accountMask: refundAccountMask(account), channelName: channel.channelName })
                sessionStorage.setItem(this.pendingKey, JSON.stringify(pending)); this.pendingAccountHash = pending.accountHash; this.pendingConfirmation = this.summaryText(pending.summary)
            }
            catch (_) { this.submitting = false; this.$message.error('无法保存本次提交记录，请检查浏览器存储后再付款'); return }
        } else {
            if (this.needsResumeAccount) {
                if (!/^\d{22}$/.test(this.resumeAccount) || refundAccountHash(this.requestNo, this.resumeAccount) !== this.pendingAccountHash) {
                    this.submitting = false; this.$message.error('账号与上次确认不一致，请重新输入原账号'); this.resolveSubmission(); return
                }
            }
            try { await this.$confirm(this.pendingConfirmation, '确认重新提交', { confirmButtonText: '重新提交', cancelButtonText: '继续等待', type: 'warning', customClass: 'refund-confirm' }) }
            catch (_) { this.submitting = false; this.resolveSubmission(); return }
        }
        if (owner !== this.pendingKey) { this.submitting = false; return }
        this.stopRecovery()
        try {
            const command = this.needsResumeAccount ? { ...this.pendingCommand, accountNumber: this.resumeAccount } : this.pendingCommand
            const order = await (this.retryOrder ? api.retry(command) : api.create(command)).toPromise()
            if (owner !== this.pendingKey) return
            if (!order || !order.id) throw new Error('未收到退款单号')
            await this.acceptSubmission(order)
        } catch (error) {
            if (owner !== this.pendingKey) return
            if (!wasUncertain && error && error.code === 'REFUND_INVALID') {
                sessionStorage.removeItem(this.pendingKey); this.uncertain = false; this.pendingCommand = null; this.requestNo = refundRequestNo()
                this.$message.error('提交失败：' + (error.msg || error.message))
            } else {
                this.uncertain = true
                this.$message.warning('暂未确认提交结果，系统正在自动核实，请勿另建退款')
            }
        }
        finally { this.submitting = false }
        if (this.uncertain) await this.resolveSubmission()
    }
    async showDetail(id: string): Promise<void> {
        const seq = ++this.detailSequence; this.detailVisible = true; this.detailLoading = true
        try { const detail = await api.detail(id).toPromise(); if (seq === this.detailSequence) this.detail = detail }
        catch (error) { this.report(error) } finally { if (seq === this.detailSequence) this.detailLoading = false }
    }
    async refresh(order: RefundOrder): Promise<void> {
        if (this.refreshing) return; this.refreshing = order.id
        try { await api.refresh(order.id).toPromise(); await this.getData(); if (this.detailVisible && this.detail && this.detail.order.id === order.id) await this.showDetail(order.id) }
        catch (error) { this.report(error) } finally { this.refreshing = '' }
    }
    openPaid(attempt: RefundAttempt): void {
        this.paidAttempt = attempt; this.paidForm = { amount: attempt.paidAt ? (attempt.paidAmount || this.detail!.order.amount) : '', providerOrderNo: attempt.providerOrderNo || '', reference: '' }; this.paidVisible = true
    }
    async confirmPaid(): Promise<void> {
        if (this.reconciling || !this.paidReady || !this.paidAttempt) return
        this.reconciling = true
        try {
            await api.confirmPaid(this.paidAttempt.id, this.paidForm.amount, this.paidForm.providerOrderNo.trim(), this.paidForm.reference.trim()).toPromise()
            this.paidVisible = false; this.$message.success('已核实付款，请在付款记录中查看记账状态')
            await this.showDetail(this.detail!.order.id); await this.getData()
        } catch (error) { this.report(error) }
        finally { this.reconciling = false }
    }
    async confirmReturn(attempt: RefundAttempt): Promise<void> {
        if (this.reconciling) return
        this.reconciling = true
        try {
            const answer = await this.$prompt('仅在渠道或银行已确认款项实际退回后操作。请填写退回流水或入账凭证号；登记后将冲正退款支出。', '登记实际退回', { confirmButtonText: '确认已实际退回', inputValidator: value => !!value && !!value.trim() && value.length <= 500 || '请填写有效凭证号' }) as any
            await api.confirmReturn(attempt.id, answer.value.trim()).toPromise(); this.$message.success('退回已登记，请在付款记录中查看冲正记账状态'); await this.showDetail(this.detail!.order.id); await this.getData()
        } catch (error) { if (error !== 'cancel' && error !== 'close') this.report(error) }
        finally { this.reconciling = false }
    }
    async confirmFailure(attempt: RefundAttempt): Promise<void> {
        if (this.reconciling) return
        this.reconciling = true
        try {
            const answer = await this.$prompt('必须已向渠道核实该笔最终未付款。超时或暂时查不到订单不能作为依据。请填写渠道确认工单或凭证号；系统会先查一次最新结果。', '核实最终未付款', { confirmButtonText: '确认渠道最终未付款', inputValidator: value => !!value && !!value.trim() && value.length <= 500 || '请填写有效渠道凭证' }) as any
            await api.confirmFailure(attempt.id, answer.value.trim()).toPromise(); await this.showDetail(this.detail!.order.id); await this.getData()
        } catch (error) { if (error !== 'cancel' && error !== 'close') this.report(error) }
        finally { this.reconciling = false }
    }
    @Watch('receiptVisible')
    receiptVisibilityChanged(): void { if (!this.receiptVisible) this.receiptData = {} }
    clearReceipt(): void { ++this.receiptSequence; this.receiptVisible = false; this.receiptLoading = ''; this.receiptData = {} }
    async showReceipt(order: RefundOrder): Promise<void> {
        if (!this.finished(order) || this.receiptLoading) return
        this.clearReceipt(); const sequence = ++this.receiptSequence; this.receiptLoading = order.id
        try {
            const receipt = await api.receipt(order.id).toPromise()
            if (sequence !== this.receiptSequence) return
            this.receiptData = refundReceiptData(receipt); this.receiptVisible = true
        } catch (error) { if (sequence === this.receiptSequence) this.report(error) }
        finally { if (sequence === this.receiptSequence) this.receiptLoading = '' }
    }
    exportPage(): void {
        const columns = ['退款单号', '用户 ID', '姓名', '关联订单号', '关联还款单号', '建单时实还金额', '收款账户', '申请金额', '实付本金', '币种', '渠道', '付款状态', '记账状态', '渠道流水', '退款原因', '操作人', '创建时间']
        const lines = this.rows.map(row => [row.id, row.customerId, row.realName, row.repaymentOrderNo, row.repaymentId, row.repaymentAmount, row.accountMask, row.amount, row.paidAmount, row.currency, row.channelName, this.statusText(row.status), this.accountingText(row.accountingState), row.providerOrderNo, row.reason, row.operatorName, this.date(row.createTime)])
        const csv = '\uFEFF' + [columns, ...lines].map(line => line.map(csvCell).join(',')).join('\r\n')
        const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' })); const link = document.createElement('a')
        link.href = url; link.download = '人工退款-当前页.csv'; link.click(); URL.revokeObjectURL(url)
    }
    report(error): void { this.$message.error(error && (error.message || error.msg) || '请求失败，请刷新查询结果') }
}
